import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AxieRotationCaptcha } from '@axieinfinity/captcha';
import { createContext, useCallback, useContext, useRef, } from 'react';
const defaultState = {
    requestCaptcha: () => Promise.resolve([undefined, undefined]),
};
export const CaptchaContext = createContext(defaultState);
let successResolver;
const getSuccessPromise = () => new Promise((resolve) => {
    successResolver = resolve;
});
let successPromise = getSuccessPromise();
const resetPromisesNResolver = () => {
    successResolver = undefined;
    successPromise = getSuccessPromise();
};
export const CaptchaProvider = ({ children, configs, }) => {
    const captchaRef = useRef(null);
    const onSuccess = (data) => {
        if (successResolver)
            successResolver([data, undefined]);
    };
    const onError = () => {
        captchaRef.current?.reset();
    };
    const onClose = () => {
        if (successResolver) {
            successResolver([undefined, undefined]);
            resetPromisesNResolver();
        }
    };
    const requestCaptcha = useCallback(async () => {
        captchaRef.current?.init();
        const rs = await successPromise;
        return rs;
    }, []);
    return (_jsxs(CaptchaContext.Provider, { value: { requestCaptcha }, children: [_jsx(AxieRotationCaptcha, { apiKey: configs.captchaKey, context: "login", url: configs.captchaUrl, onSuccess: onSuccess, onFailure: onError, onClose: onClose, ref: captchaRef }, void 0), children] }, void 0));
};
export const useCaptcha = () => useContext(CaptchaContext);
export * from '@axieinfinity/captcha';
//# sourceMappingURL=captcha.js.map